<template>
  <v-container class="pa-0">
    <v-toolbar dark :color="appColor_Medium">
      <v-toolbar-title>
        <span><v-icon class="mr-2">security</v-icon>Change Password</span>
      </v-toolbar-title>
    </v-toolbar>
    <v-card>
      <v-card-text class="pb-0">
        <v-container
          grid-list-md
          class="pa-0"
        >
          <v-form>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                >
                <v-text-field
                  v-model="password"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="show ? 'text' : 'password'"
                  name="input-10-1"
                  label="New Password"
                  hint="At least 8 characters"
                  counter
                  @click:append="show = !show"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pt-4 pb-4">
        <v-spacer />
        <v-btn
          text
          :disabled="isSaving"
          @click="$emit('close')"
          >
          Cancel
        </v-btn>        
        <v-btn
          color="blue darken-1"
          text
          :loading="isSaving"
          :disabled="!valid || isSaving"
          @click="save"
          >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Error Dialog -->
    <v-dialog
      v-model="errorDialog"
      max-width="400px"
      >
      <app-error
        :error-title="errorTitle"
        :error-text="errorText"
        :error-severity="errorSeverity"
        @close="errorDialog = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import appService from '@/app.service'
import AppError from '@/components/AppError'
import { AppColor } from '@/config.js'

export default {
  name: 'ProfilePassword',
  components: {
    AppError
  },
  props: {
    userId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      appColor_Medium: AppColor.Medium,

      isSaving: false,
      show: false,
      password: '',
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
      },

      // error handling
      errorDialog: false,
      errorTitle: 'Internal Error',
      errorText: null,
      errorSeverity: null
    }
  },
  computed: {
    valid () {
      return this.password.length >= 8
    }
  },
  methods: {
    save () {
      const self = this
      self.isSaving = true
      appService.updateUserPassword(self.userId, { password: self.password }).then(data => {
        if (data.errorSeverity > 0) {
          self.$emit('error', data.errorMessage)
        } else {
          self.$emit('close')
        }
        self.isSaving = false
      })
    }
  }
}
</script>
